import {
    ADMINADDNEWBANK_SUCCESS,
    ADMINADDNEWBANK_FAILED,
    RESET_ADMINADDNEWBANK,
    LOADING_ADMINADDNEWBANK,
    NETWORK_ERROR_ADMINADDNEWBANK
} from "../types/index";
import { adminServices } from "../../config/axios";


const resetAdminAddNewBank = () => {
    return { type: RESET_ADMINADDNEWBANK };
};

const adminAddNewBankList = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_ADMINADDNEWBANK });
    await adminServices
        .post("addNewBank", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(adminAddNewBankListsuccess(res.data));
                    break;
                default:
                    dispatch(adminAddNewBankListFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_ADMINADDNEWBANK,
                payload: err
            });
        });
};


function adminAddNewBankListsuccess(data) {
    return {
        type: ADMINADDNEWBANK_SUCCESS,
        payload: data
    };
}
function adminAddNewBankListFailed(data) {
    return {
        type: ADMINADDNEWBANK_FAILED,
        payload: data
    };
}

export { adminAddNewBankList, resetAdminAddNewBank }